/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import template from './welcome-data-page.component.html';

@Component({
  standalone: false,
  selector: 'adn-welcome-data-page',
  template
})
export class WelcomeDataPageComponent {
}
